export default __webpack_public_path__ + "static/media/Icon-Chevron-Right-Green.47d800d0.svg";